
const INITIAL_STATE = {}

const custPrdLstReducer = (state = INITIAL_STATE, action) => {
        switch (action.type) {
                case "GET_DATA_CUSTPRDLST":
                         return { ...state, listaCustPrdLst: action.payload.data }
                case "GET_DATA_LSTRVD":
                        return { ...state, ListaTdsRevendas: action.payload.data }
                default:
                        return state
        }
}
export default custPrdLstReducer;
